import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CatalogRoutingModule } from './catalog-routing.module';
import { ProductCatalogComponent } from './containers/product-catalog/product-catalog.component';
import { ProductCardComponent } from './components/product-card/product-card.component';
import { CollectionOverviewComponent } from './containers/collection-overview/collection-overview.component';
import { CollectionCardComponent } from './components/collection-card/collection-card.component';
import { TextUtilityModule } from '@teamfoster/sdk/text-utility';
import { PaginationComponent } from './components/pagination/pagination.component';
import { ProductDetailComponent } from './containers/product-detail/product-detail.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ShopModule } from '../shop/shop.module';
import { CoreModule } from '../core/core.module';
import { ProductImageSliderComponent } from './components/product-image-slider/product-image-slider.component';
import { DictionaryNgrxModule } from '@teamfoster/sdk/dictionary-ngrx';
import { ProductAmountComponent } from './components/product-amount/product-amount.component';

import { InViewModule } from '@teamfoster/sdk/in-view';
import { ProductVariantOptionsComponent } from './components/product-variant-options/product-variant-options.component';
import { ProductSpecificationsComponent } from './components/product-specifications/product-specifications.component';
import { RouterModule } from '@angular/router';
import { ProductFiltersComponent } from './components/product-filters/product-filters.component';
import { DynamicFormModule } from '@teamfoster/dynamic-forms';
import { SeoModule } from '../seo/seo.module';
import { ProductVariantImageSliderComponent } from './components/product-variant-image-slider/product-variant-image-slider.component';
import { VariantCardComponent } from './components/variant-card/variant-card.component';
import { ProductSwatchListComponent } from './components/product-swatch-list/product-swatch-list.component';
import { CollectionHeaderComponent } from './components/collection-header/collection-header.component';
import { ImageModule } from '@teamfoster/sdk/image';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonModule } from '@teamfoster/sdk/button';
import { ShopifyMediaItemComponent } from './components/shopify-media-item/shopify-media-item.component';
import { Html5VideoPlayerModule } from '@teamfoster/sdk/html5-video-player';
import { VariantSwatchListComponent } from './components/variant-swatch-list/variant-swatch-list.component';
import { SearchResultsComponent } from './containers/search-results/search-results.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { NotifyMeDialogComponent } from './components/notify-me-dialog/notify-me-dialog.component';

const moduleExports = [
  ProductCatalogComponent,
  ProductCardComponent,
  CollectionOverviewComponent,
  CollectionCardComponent,
  PaginationComponent,
  ProductDetailComponent,
  ProductAmountComponent,
];
@NgModule({
  declarations: [
    ...moduleExports,
    ProductImageSliderComponent,
    ProductVariantOptionsComponent,
    ProductSpecificationsComponent,
    ProductFiltersComponent,
    ProductVariantImageSliderComponent,
    VariantCardComponent,
    ProductSwatchListComponent,
    CollectionHeaderComponent,
    ShopifyMediaItemComponent,
    VariantSwatchListComponent,
    SearchResultsComponent,
    NotifyMeDialogComponent,
  ],
  imports: [
    CommonModule,
    CatalogRoutingModule,
    TextUtilityModule,
    ShopModule,
    CoreModule,
    DictionaryNgrxModule,
    InViewModule,
    ImageModule,
    RouterModule,
    DynamicFormModule,
    SeoModule,
    MatTooltipModule,
    ButtonModule,
    Html5VideoPlayerModule,
    CoreModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
  ],
  exports: [...moduleExports],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CatalogModule {}
